<template>
  <div class="admin-settings">
    <header-title :title="title"></header-title>

    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
    <br />
    <v-container fluid class="pl-0 pr-0">
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Activar Impresoras :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="2" class="py-0 py-sm-1 d-flex">
            <v-switch
              class="mt-2"
              v-model="input.activePrinters"
              @change="updateActivePrinters"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Temporizador de Marchar Segundos:
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-select
              :items="getNumbers"
              v-model="input.timerSeconds"
              @change="updateTimerSeconds"
              class="ml-2"
              style="width: 100%; max-width: 90px"
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Tiempo de caducidad del QR:
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-select
              :items="getQRExpirationTime"
              v-model="input.qrExpiry"
              item-text="label"
              item-value="value"
              @change="updateQRExpirationTime"
              class="ml-2"
              style="width: 100%; max-width: 90px"
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Temporizador Cerrar Mesa si la cuenta está a 0:
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-select
              :items="getNumbers"
              v-model="input.tableCloseTimer"
              @change="updateTableCloseTimer"
              class="ml-2"
              style="width: 100%; max-width: 90px"
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Mostrar solo la Carta :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-switch
              class="mt-2"
              v-model="input.isActiveSoloCarta"
              @change="updateActiveSoloCarta"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Mostrar traducciones :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-switch
              class="mt-2"
              v-model="input.isActiveTranslator"
              @change="updateActiveTranslator"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Elige el método de pago :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-select
              v-model="input.paymentMethod"
              :items="allPaymentMethod"
              item-text="label"
              item-value="value"
              style="width: 130px"
              @change="updatePaymentMethod"
              class="mx-sm-3"
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Activar Bizum:
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-select
              v-model="input.enableBizum"
              :items="paymentMethodTypeVisibilityItems"
              item-text="label"
              item-value="value"
              style="width: 130px"
              @change="updatePaymentMethodVisibility($event, 'enableBizum')"
              class="mx-sm-3"
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Activar Google pay:
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-select
              v-model="input.enableGooglePay"
              :items="paymentMethodTypeVisibilityItems"
              item-text="label"
              item-value="value"
              style="width: 130px"
              @change="updatePaymentMethodVisibility($event, 'enableGooglePay')"
              class="mx-sm-3"
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Activar Apple pay:
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <v-select
              v-model="input.enableApplePay"
              :items="paymentMethodTypeVisibilityItems"
              item-text="label"
              item-value="value"
              style="width: 130px"
              @change="updatePaymentMethodVisibility($event, 'enableApplePay')"
              class="mx-sm-3"
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col align="center">
            <div class="my-2 mr-5">
              <v-btn
                dense
                outlined
                @click="onSaveSetting"
                type="button"
                :style="adminNavigationBackTheme"
              >
                Guardar
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import Loader from "@/components/common/Loader";
import firebaseMixin from "../../../mixins/firebase/firebaseMixin";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { getQRExpirationTime } from "@/utils/constant";
import { getSettingById, saveSetting } from "@/collections/settings";
import { qrZoneCollection, updateQrZone } from "@/collections/qrZone";

export default {
  name: "Settings-Config",
  components: { Loader, HeaderTitle },
  mixins: [firebaseMixin],
  data() {
    return {
      dialogLoader: false,
      title: "Configuración",
      input: {
        initializedProject: false,
        activePrinters: false,
        isActiveSoloCarta: false,
        timerSeconds: 0,
        paymentMethod: "nomobilepayment",
        tableCloseTimer: 0,
        enableBizum: undefined,
        enableGooglePay: undefined,
        enableApplePay: undefined,
        qrExpiry: null,
        isActiveTranslator: false
      },
      getQRExpirationTime: [...getQRExpirationTime],
      allPaymentMethod: [
        {
          label: "Stripe",
          value: "stripe"
        },
        {
          label: "Redsys",
          value: "redsys"
        },
        {
          label: "Sin Pago de Movil",
          value: "nomobilepayment"
        }
      ],
      paymentMethodTypeVisibilityItems: [
        {
          label: "Si",
          value: true
        },
        {
          label: "No",
          value: false
        }
      ],
      qrZoneCollection: []
    };
  },
  firestore() {
    return {
      qrZoneCollection: qrZoneCollection
    };
  },
  computed: {
    getNumbers() {
      let timeSec = ["0 sec", "5 sec", "15 sec"];
      timeSec.unshift("NO");
      let timeMin = new Array(20).fill(1).map((n, i) => {
        let number = n + i;
        return number + " ".concat("min");
      });
      return timeSec.concat(timeMin);
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    async updateActivePrinters(value) {
      try {
        await saveSetting("settings", {
          ...this.input,
          activePrinters: value
        });
      } catch (error) {
        this.setlogError(
          "save_setting",
          "Obtained error message in updateActivePrinters()",
          error.stack,
          this.$options.name
        );
      }
    },
    async updateActiveSoloCarta(value) {
      try {
        await saveSetting("settings", {
          ...this.input,
          isActiveSoloCarta: value
        });
      } catch (error) {
        this.setlogError(
          "save_setting",
          "Obtained error message in updateActiveSoloCarta()",
          error.stack,
          this.$options.name
        );
      }
    },
    async updateActiveTranslator(value) {
      try {
        await saveSetting("settings", {
          ...this.input,
          isActiveTranslator: value
        });
      } catch (error) {
        this.setlogError(
          "save_setting",
          "Obtained error message in updateActiveTranslator()",
          error.stack,
          this.$options.name
        );
      }
    },
    async updatePaymentMethod(value) {
      try {
        await saveSetting("settings", {
          ...this.input,
          paymentMethod: value
        });
      } catch (error) {
        this.setlogError(
          "save_setting",
          "Obtained error message in updatePaymentMethod()",
          error.stack,
          this.$options.name
        );
      }
    },
    async updatePaymentMethodVisibility(value, paymentTypeKey) {
      try {
        await saveSetting("settings", {
          ...this.input,
          [paymentTypeKey]: value
        });
      } catch (error) {
        this.setlogError(
          "save_setting",
          "Obtained error message in updatePaymentMethodVisibility()",
          error.stack,
          this.$options.name
        );
      }
    },
    async updateQRExpirationTime(value) {
      try {
        await saveSetting("settings", {
          ...this.input,
          qrExpiry: value
        });
      } catch (error) {
        this.setlogError(
          "save_setting",
          "Obtained error message in updateQRExpirationTime()",
          error.stack,
          this.$options.name
        );
      }
    },
    async updateTimerSeconds(value) {
      try {
        await saveSetting("settings", {
          ...this.input,
          timerSeconds: value
        });
      } catch (error) {
        this.setlogError(
          "save_setting",
          "Obtained error message in updateTimerSeconds()",
          error.stack,
          this.$options.name
        );
      }
    },
    async updateTableCloseTimer(value) {
      try {
        await saveSetting("settings", {
          ...this.input,
          tableCloseTimer: value
        });
      } catch (error) {
        this.setlogError(
          "save_setting",
          "Obtained error message in updateTableCloseTimer()",
          error.stack,
          this.$options.name
        );
      }
    },
    async getData() {
      let self = this;
      this.dialogLoader = true;

      let setting;
      try {
        setting = await getSettingById("settings");

        self.dialogLoader = false;
        self.input = setting;

        if (self.input.initializedProject === undefined) {
          self.input = {
            ...self.input,
            initializedProject: false
          };
        }

        if (self.input.activePrinters === undefined) {
          self.input = {
            ...self.input,
            activePrinters: false
          };
        }

        if (self.input.isActiveSoloCarta === undefined) {
          self.input = {
            ...self.input,
            isActiveSoloCarta: false
          };
        }

        if (self.input.timerSeconds === undefined) {
          self.input = {
            ...self.input,
            timerSeconds: 0
          };
        }
      } catch (error) {
        this.setlogError(
          "get_setting",
          "Error obteniendo settings",
          error.stack,
          this.$options.name
        );
        self.dialogLoader = false;
      }
    },
    async onSaveSetting() {
      try {
        if (
          this.input.paymentMethod &&
          this.input.paymentMethod === "nomobilepayment"
        ) {
          this.qrZoneCollection.forEach(async zone => {
            try {
              await updateQrZone(zone.id, { acceptDirectPayment: false });
            } catch (error) {
              this.setlogError(
                "update_qr_zone",
                "Obtained error message in onSaveSetting()",
                error.stack,
                this.$options.name
              );
            }
          });
        }

        await saveSetting("settings", {
          ...this.input
        });

        this.showSuccessMessage("Configuración guardada");
      } catch (error) {
        let message = "Algo salió mal";
        this.setlogError(
          "save_setting",
          "Obtained error message in onSaveSetting()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage(message);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.icons-img {
  width: 100px;
  height: 100px;
  align-items: center;
  display: flex;
  padding: 10px;
  border: 2px solid darkgray;
  justify-content: center;
  min-width: 100px;
}
.icons-img img {
  max-width: 100%;
  max-height: 80px;
}
</style>
